.overview {
  display: flex;
  justify-content: start;
  margin: 10px 0;
}
.overview .overview-content {
  display: flex;
}
.overview .overview-content.with-image .info {
  margin-left: 10px;
}
.overview img {
  width: auto;
  height: 140px;
}
.overview .info {
  display: flex;
  flex-direction: column;
}
.overview .info h3 {
  margin-top: 0;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2hvbWUvanRyZW1ibGF5L3NvbHV0aW9uc3RsbS50aWNrZXRpbmdzeXN0ZW0vc3JjL3RzLmludGVybmV0c2FsZS4zLjAvcGFja2FnZXMvdWkvc3JjL2NvbXBvbmVudHMvbW9sZWN1bGVzL2J1eXRpY2tldHMiLCJzb3VyY2VzIjpbImxpdGUtc2hvcC1wcm9kdWN0LW92ZXJ2aWV3LnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDSTtFQUNBO0VBQ0E7O0FBRUE7RUFDSTs7QUFFSTtFQUNJOztBQUtaO0VBQ0k7RUFDQTs7QUFHSjtFQUNJO0VBQ0E7O0FBRUE7RUFDSSIsInNvdXJjZXNDb250ZW50IjpbIi5vdmVydmlldyB7XG4gICAgZGlzcGxheTogZmxleDtcbiAgICBqdXN0aWZ5LWNvbnRlbnQ6IHN0YXJ0O1xuICAgIG1hcmdpbjogMTBweCAwO1xuXG4gICAgLm92ZXJ2aWV3LWNvbnRlbnQge1xuICAgICAgICBkaXNwbGF5OiBmbGV4O1xuICAgICAgICAmLndpdGgtaW1hZ2Uge1xuICAgICAgICAgICAgLmluZm8ge1xuICAgICAgICAgICAgICAgIG1hcmdpbi1sZWZ0OiAxMHB4O1xuICAgICAgICAgICAgfVxuICAgICAgICB9XG4gICAgfVxuICAgIFxuICAgIGltZyB7XG4gICAgICAgIHdpZHRoOiBhdXRvO1xuICAgICAgICBoZWlnaHQ6IDE0MHB4O1xuICAgIH1cblxuICAgIC5pbmZvIHtcbiAgICAgICAgZGlzcGxheTogZmxleDtcbiAgICAgICAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcbiAgICAgICAgXG4gICAgICAgIGgzIHtcbiAgICAgICAgICAgIG1hcmdpbi10b3A6IDA7XG4gICAgICAgIH1cbiAgICB9XG59Il19 */